import { useQuery } from '@tanstack/react-query';

import axiosInstance from 'src/utils/axios';

const getUser = async () => {
  const response = await axiosInstance.get('/user');
  return response.data;
};

export function useGetUserId(isAuthTokenSet: boolean) {
  const { data: id } = useQuery({
    queryKey: ['user'],
    queryFn: getUser,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: isAuthTokenSet,
  });

  return { id };
}
